module.exports = __webpack_public_path__ + "img/loading.49f931e9.gif";